// categoryData.js

export const ARCHITECTURE_CATEGORIES = {
  fr: [
    { slug: "interior-architect", label: "Architecte Intérieur" },
    { slug: "interior-designer", label: "Designer Intérieur" },
    { slug: "interior-fitting", label: "Aménagement Intérieur" },
    { slug: "interior-decoration", label: "Décoration Intérieure" },
    { slug: "energy-renovation", label: "Rénovation Énergétique" },
    { slug: "innovation-architect", label: "Architecte de l'Innovation" },
    { slug: "landscape-architect", label: "Architecte Paysagiste" },
    { slug: "housing", label: "Logement" },
    { slug: "urbanism", label: "Urbanisme" },
    { slug: "public-infrastructure", label: "Infrastructures Publiques" },
    { slug: "mixed-buildings", label: "Immeubles Mixtes" },
    { slug: "luxury", label: "Luxe" },
    { slug: "artwork-structure", label: "Ouvrage d'Art" },
    { slug: "residential", label: "Résidentiel" },
    { slug: "office", label: "Bureau" },
    { slug: "industrial-buildings", label: "Bâtiments Industriels" },
    { slug: "draftsman", label: "Dessinateur" },
    { slug: "architect", label: "Architecte" },
    { slug: "project-manager", label: "Chef de projet" },
    { slug: "bim-modeler", label: "BIM Modeleur" },
    { slug: "bim-manager", label: "BIM Manager" },
  ],
  en: [
    { slug: "interior-architect", label: "Interior Architect" },
    { slug: "interior-designer", label: "Interior Designer" },
    { slug: "interior-fitting", label: "Interior Fitting" },
    { slug: "interior-decoration", label: "Interior Decoration" },
    { slug: "energy-renovation", label: "Energy Renovation" },
    { slug: "innovation-architect", label: "Innovation Architect" },
    { slug: "landscape-architect", label: "Landscape Architect" },
    { slug: "housing", label: "Housing" },
    { slug: "urbanism", label: "Urbanism" },
    { slug: "public-infrastructure", label: "Public Infrastructure" },
    { slug: "mixed-buildings", label: "Mixed-Use Buildings" },
    { slug: "luxury", label: "Luxury" },
    { slug: "artwork-structure", label: "Artwork Structure" },
    { slug: "residential", label: "Residential" },
    { slug: "office", label: "Office" },
    { slug: "industrial-buildings", label: "Industrial Buildings" },
    { slug: "draftsman", label: "Draftsman" },
    { slug: "architect", label: "Architect" },
    { slug: "project-manager", label: "Project Manager" },
    { slug: "bim-modeler", label: "BIM Modeler" },
    { slug: "bim-manager", label: "BIM Manager" },
  ],
  nl: [
    { slug: "interior-architect", label: "Binnenhuisarchitect" },
    { slug: "interior-designer", label: "Interieurontwerper" },
    { slug: "interior-fitting", label: "Interieuraanpassing" },
    { slug: "interior-decoration", label: "Interieurdecoratie" },
    { slug: "energy-renovation", label: "Energetische renovatie" },
    { slug: "innovation-architect", label: "Innovatiearchitect" },
    { slug: "landscape-architect", label: "Landschapsarchitect" },
    { slug: "housing", label: "Woning" },
    { slug: "urbanism", label: "Urbanisme" },
    { slug: "public-infrastructure", label: "Publieke Infrastructuur" },
    { slug: "mixed-buildings", label: "Gemengde Gebouwen" },
    { slug: "luxury", label: "Luxe" },
    { slug: "artwork-structure", label: "Kunstwerk Constructie" },
    { slug: "residential", label: "Residentieel" },
    { slug: "office", label: "Kantoor" },
    { slug: "industrial-buildings", label: "Industriële Gebouwen" },
    { slug: "draftsman", label: "Tekenaar" },
    { slug: "architect", label: "Architect" },
    { slug: "project-manager", label: "Projectmanager" },
    { slug: "bim-modeler", label: "BIM-Modelleur" },
    { slug: "bim-manager", label: "BIM-Manager" },
  ],
};

export const ENGINEERING_CATEGORIES = {
  fr: [
    { slug: "civil-engineer", label: "Ingénieur Génie Civil" },
    { slug: "acoustic-engineer", label: "Ingénieur Acoustique" },
    { slug: "geotechnical-engineer", label: "Ingénieur Géotechnique" },
    { slug: "industrial-engineer", label: "Ingénieur Industriel en Construction" },
    { slug: "robotics-engineer", label: "Ingénieur Robotique" },
    { slug: "territorial-planner", label: "Aménageur du Territoire" },
    { slug: "urban-planner", label: "Urbaniste" },
    { slug: "sanitation-engineer", label: "Ingénieur Assainissement" },
    { slug: "renewable-energy-engineer", label: "Ingénieur Énergies Renouvelables" },
    { slug: "mechanical-engineer", label: "Ingénieur Mécanique" },
    { slug: "energy-transition-expert", label: "Expert en Transition Énergétique" },
    { slug: "special-techniques-engineer", label: "Ingénieur en Techniques Spéciales" },
    { slug: "infrastructure-engineer", label: "Ingénieur Infrastructure" },
    { slug: "construction-engineer", label: "Ingénieur Construction" },
    { slug: "automation-engineer", label: "Ingénieur Automatisation" },
    { slug: "electromechanical-engineer", label: "Ingénieur Électromécanique" },
    { slug: "heavy-industry-engineer", label: "Ingénieur Industrie Lourde" },
    { slug: "aerospace-engineer", label: "Ingénieur Aérospatial" },
    { slug: "management-engineer", label: "Ingénieur Management" },
    { slug: "hvac", label: "HVAC" },
    { slug: "technical-manager", label: "Responsable Technique" },
    { slug: "industrial-drafter", label: "Dessinateur Industriel" },
    { slug: "technical-drafter", label: "Dessinateur Technique" },
    { slug: "maintenance-manager", label: "Responsable Maintenance" },
    { slug: "electrical-engineer", label: "Ingénieur Électricité" },
    { slug: "turner", label: "Tourneur" },
    { slug: "miller", label: "Fraiseur" },
    { slug: "production-operator", label: "Opérateur de production" },
    { slug: "industrial-buyer", label: "Acheteur Industriel" },
    { slug: "workshop-manager", label: "Chef d'atelier" },
    { slug: "hse-engineer", label: "Ingénieur HSE" },
    { slug: "qhse-engineer", label: "Ingénieur QHSE" },
    { slug: "prevention-advisor", label: "Conseiller en Prévention" },
  ],
  en: [
    { slug: "civil-engineer", label: "Civil Engineer" },
    { slug: "acoustic-engineer", label: "Acoustic Engineer" },
    { slug: "geotechnical-engineer", label: "Geotechnical Engineer" },
    { slug: "industrial-engineer", label: "Industrial Engineer in Construction" },
    { slug: "robotics-engineer", label: "Robotics Engineer" },
    { slug: "territorial-planner", label: "Territorial Planner" },
    { slug: "urban-planner", label: "Urban Planner" },
    { slug: "sanitation-engineer", label: "Sanitation Engineer" },
    { slug: "renewable-energy-engineer", label: "Renewable Energy Engineer" },
    { slug: "mechanical-engineer", label: "Mechanical Engineer" },
    { slug: "energy-transition-expert", label: "Energy Transition Expert" },
    { slug: "special-techniques-engineer", label: "Special Techniques Engineer" },
    { slug: "infrastructure-engineer", label: "Infrastructure Engineer" },
    { slug: "construction-engineer", label: "Construction Engineer" },
    { slug: "automation-engineer", label: "Automation Engineer" },
    { slug: "electromechanical-engineer", label: "Electromechanical Engineer" },
    { slug: "heavy-industry-engineer", label: "Heavy Industry Engineer" },
    { slug: "aerospace-engineer", label: "Aerospace Engineer" },
    { slug: "management-engineer", label: "Management Engineer" },
    { slug: "hvac", label: "HVAC" },
    { slug: "technical-manager", label: "Technical Manager" },
    { slug: "industrial-drafter", label: "Industrial Drafter" },
    { slug: "technical-drafter", label: "Technical Drafter" },
    { slug: "maintenance-manager", label: "Maintenance Manager" },
    { slug: "electrical-engineer", label: "Electrical Engineer" },
    { slug: "turner", label: "Turner" },
    { slug: "miller", label: "Miller" },
    { slug: "production-operator", label: "Production Operator" },
    { slug: "industrial-buyer", label: "Industrial Buyer" },
    { slug: "workshop-manager", label: "Workshop Manager" },
    { slug: "hse-engineer", label: "HSE Engineer" },
    { slug: "qhse-engineer", label: "QHSE Engineer" },
    { slug: "prevention-advisor", label: "Prevention Advisor" },
  ],
  nl: [
    { slug: "civil-engineer", label: "Burgerlijk Ingenieur" },
    { slug: "acoustic-engineer", label: "Akoestisch Ingenieur" },
    { slug: "geotechnical-engineer", label: "Geotechnisch Ingenieur" },
    { slug: "industrial-engineer", label: "Industrieel Ingenieur Bouwkunde" },
    { slug: "robotics-engineer", label: "Robotica Ingenieur" },
    { slug: "territorial-planner", label: "Ruimtelijke Planner" },
    { slug: "urban-planner", label: "Stedenbouwkundige" },
    { slug: "sanitation-engineer", label: "Sanitair Ingenieur" },
    { slug: "renewable-energy-engineer", label: "Ingenieur Hernieuwbare Energie" },
    { slug: "mechanical-engineer", label: "Mechanisch Ingenieur" },
    { slug: "energy-transition-expert", label: "Energietransitie Expert" },
    { slug: "special-techniques-engineer", label: "Ingenieur Speciale Technieken" },
    { slug: "infrastructure-engineer", label: "Infrastructuur Ingenieur" },
    { slug: "construction-engineer", label: "Bouwkundig Ingenieur" },
    { slug: "automation-engineer", label: "Automatiseringsingenieur" },
    { slug: "electromechanical-engineer", label: "Elektromechanisch Ingenieur" },
    { slug: "heavy-industry-engineer", label: "Ingenieur Zware Industrie" },
    { slug: "aerospace-engineer", label: "Lucht- en Ruimtevaartingenieur" },
    { slug: "management-engineer", label: "Management Ingenieur" },
    { slug: "hvac", label: "HVAC" },
    { slug: "technical-manager", label: "Technisch Verantwoordelijke" },
    { slug: "industrial-drafter", label: "Industrieel Tekenaar" },
    { slug: "technical-drafter", label: "Technisch Tekenaar" },
    { slug: "maintenance-manager", label: "Onderhoudsmanager" },
    { slug: "electrical-engineer", label: "Elektrisch Ingenieur" },
    { slug: "turner", label: "Draaier" },
    { slug: "miller", label: "Frezer" },
    { slug: "production-operator", label: "Productie-operator" },
    { slug: "industrial-buyer", label: "Industrieel Aankoper" },
    { slug: "workshop-manager", label: "Werkplaatsmanager" },
    { slug: "hse-engineer", label: "HSE-ingenieur" },
    { slug: "qhse-engineer", label: "QHSE-ingenieur" },
    { slug: "prevention-advisor", label: "Preventieadviseur" },
  ],
};


export const CONSTRUCTION_CATEGORIES = {
  fr: [
    { slug: "workshop", label: "Atelier" },
    { slug: "carpenter", label: "Charpentier" },
    { slug: "estimator", label: "Deviseur" },
    { slug: "plumbing-specialist", label: "Sanitariste" },
    { slug: "heavy-truck-driver", label: "Chauffeur Poids Lourd" },
    { slug: "site-supervisor", label: "Conducteur Travaux" },
    { slug: "roofer", label: "Couvreur" },
    { slug: "BIM", label: "BIM" },
    { slug: "peb-certifier", label: "Certificateur PEB" },
    { slug: "sustainable-construction", label: "Construction Durable" },
    { slug: "metal-construction", label: "Construction Métallique" },
    { slug: "modular-construction", label: "Construction Modulaire" },
    { slug: "rope-worker", label: "Cordiste" },
    { slug: "electrician", label: "Électricien" },
    { slug: "site-manager", label: "Gestionnaire de Chantier" },
    { slug: "mason", label: "Maçon" },
    { slug: "commercial-real-estate", label: "Immobilier d'Entreprise" },
    { slug: "electromechanic", label: "Électromécanicien" },
    { slug: "installer", label: "Installateur" },
    { slug: "insulation", label: "Isolation" },
    { slug: "warehouse-clerk", label: "Magasinier" },
    { slug: "plumber", label: "Plombier" },
    { slug: "safe-manager", label: "Safe Manager" },
    { slug: "safety-manager", label: "Safety Manager" },
    { slug: "prevention-advisor", label: "Conseiller en Prévention" },
    { slug: "building", label: "Bâtiment" },
    { slug: "public-works-and-construction", label: "Travaux Publics et Construction" },
    { slug: "recycling", label: "Recyclage" },
    { slug: "elevator-technician", label: "Technicien Ascenseur" },
    { slug: "technician", label: "Technicien" },
    { slug: "public-works", label: "Travaux Publics" },
    { slug: "engineering-structure", label: "Ouvrage d'Art" },
    { slug: "residential", label: "Résidentiel" },
    { slug: "office", label: "Bureau" },
    { slug: "industrial-buildings", label: "Bâtiments Industriels" },
    { slug: "urbanism", label: "Urbanisme" },
    { slug: "public-infrastructure", label: "Infrastructures Publiques" },
    { slug: "mixed-buildings", label: "Immeubles Mixtes" },
    { slug: "general-construction", label: "Construction Générale" },
    { slug: "demolition", label: "Démolition" },
    { slug: "roadworks", label: "Voirie" },
    { slug: "mechanic", label: "Mécanicien" },
    { slug: "maintenance", label: "Maintenance" },
    { slug: "surveyor", label: "Géomètre" },
    { slug: "fitter", label: "Monteur" },
    { slug: "laborer", label: "Manœuvre" },
    { slug: "buyer", label: "Acheteur" },
    { slug: "heating-engineer", label: "Chauffagiste" },
    { slug: "team-leader", label: "Chef d'équipe" },
    { slug: "joiner", label: "Menuisier" },
  ],
  en: [
    { slug: "workshop", label: "Workshop" },
    { slug: "carpenter", label: "Carpenter" },
    { slug: "estimator", label: "Estimator" },
    { slug: "plumbing-specialist", label: "Plumbing Specialist" },
    { slug: "heavy-truck-driver", label: "Heavy Truck Driver" },
    { slug: "site-supervisor", label: "Site Supervisor" },
    { slug: "roofer", label: "Roofer" },
    { slug: "BIM", label: "BIM" },
    { slug: "peb-certifier", label: "PEB Certifier" },
    { slug: "sustainable-construction", label: "Sustainable Construction" },
    { slug: "metal-construction", label: "Metal Construction" },
    { slug: "modular-construction", label: "Modular Construction" },
    { slug: "rope-worker", label: "Rope Worker" },
    { slug: "electrician", label: "Electrician" },
    { slug: "site-manager", label: "Site Manager" },
    { slug: "mason", label: "Mason" },
    { slug: "commercial-real-estate", label: "Commercial Real Estate" },
    { slug: "electromechanic", label: "Electromechanic" },
    { slug: "installer", label: "Installer" },
    { slug: "insulation", label: "Insulation" },
    { slug: "warehouse-clerk", label: "Warehouse Clerk" },
    { slug: "plumber", label: "Plumber" },
    { slug: "safe-manager", label: "Safe Manager" },
    { slug: "safety-manager", label: "Safety Manager" },
    { slug: "prevention-advisor", label: "Prevention Advisor" },
    { slug: "building", label: "Building" },
    { slug: "public-works-and-construction", label: "Public Works and Construction" },
    { slug: "recycling", label: "Recycling" },
    { slug: "elevator-technician", label: "Elevator Technician" },
    { slug: "technician", label: "Technician" },
    { slug: "public-works", label: "Public Works" },
    { slug: "engineering-structure", label: "Engineering Structure" },
    { slug: "residential", label: "Residential" },
    { slug: "office", label: "Office" },
    { slug: "industrial-buildings", label: "Industrial Buildings" },
    { slug: "urbanism", label: "Urbanism" },
    { slug: "public-infrastructure", label: "Public Infrastructure" },
    { slug: "mixed-buildings", label: "Mixed-Use Buildings" },
    { slug: "general-construction", label: "General Construction" },
    { slug: "demolition", label: "Demolition" },
    { slug: "roadworks", label: "Roadworks" },
    { slug: "mechanic", label: "Mechanic" },
    { slug: "maintenance", label: "Maintenance" },
    { slug: "surveyor", label: "Surveyor" },
    { slug: "fitter", label: "Fitter / Assembler" },
    { slug: "laborer", label: "General Laborer" },
    { slug: "buyer", label: "Buyer" },
    { slug: "heating-engineer", label: "Heating Engineer" },
    { slug: "team-leader", label: "Team Leader" },
    { slug: "joiner", label: "Joiner" },
  ],
  nl: [
    { slug: "workshop", label: "Werkplaats" },
    { slug: "carpenter", label: "Timmerman" },
    { slug: "estimator", label: "Calculator" },
    { slug: "plumbing-specialist", label: "Sanitairspecialist" },
    { slug: "heavy-truck-driver", label: "Vrachtwagenchauffeur" },
    { slug: "site-supervisor", label: "Werfleider" },
    { slug: "roofer", label: "Dakdekker" },
    { slug: "BIM", label: "BIM" },
    { slug: "peb-certifier", label: "PEB Certificator" },
    { slug: "sustainable-construction", label: "Duurzame Bouw" },
    { slug: "metal-construction", label: "Metaalconstructie" },
    { slug: "modular-construction", label: "Modulaire Constructie" },
    { slug: "rope-worker", label: "Touwwerker" },
    { slug: "electrician", label: "Elektricien" },
    { slug: "site-manager", label: "Werfbeheerder" },
    { slug: "mason", label: "Metselaar" },
    { slug: "commercial-real-estate", label: "Bedrijfsvastgoed" },
    { slug: "electromechanic", label: "Elektromechanieker" },
    { slug: "installer", label: "Installateur" },
    { slug: "insulation", label: "Isolatie" },
    { slug: "warehouse-clerk", label: "Magazijnier" },
    { slug: "plumber", label: "Loodgieter" },
    { slug: "safe-manager", label: "Veiligheidsmanager" },
    { slug: "safety-manager", label: "Safety Manager" },
    { slug: "prevention-advisor", label: "Preventieadviseur" },
    { slug: "building", label: "Bouw" },
    { slug: "public-works-and-construction", label: "Openbare Werken en Bouw" },
    { slug: "recycling", label: "Recyclage" },
    { slug: "elevator-technician", label: "Lifttechnicus" },
    { slug: "technician", label: "Technieker" },
    { slug: "public-works", label: "Openbare Werken" },
    { slug: "engineering-structure", label: "Kunstwerk Constructie" },
    { slug: "residential", label: "Residentieel" },
    { slug: "office", label: "Kantoor" },
    { slug: "industrial-buildings", label: "Industriële Gebouwen" },
    { slug: "urbanism", label: "Stedelijke Planning" },
    { slug: "public-infrastructure", label: "Publieke Infrastructuur" },
    { slug: "mixed-buildings", label: "Gemengde Gebouwen" },
    { slug: "general-construction", label: "Algemene Bouw" },
    { slug: "demolition", label: "Sloopwerk" },
    { slug: "roadworks", label: "Wegenwerken" },
    { slug: "mechanic", label: "Mechanicien" },
    { slug: "maintenance", label: "Onderhoud" },
    { slug: "surveyor", label: "Landmeter" },
    { slug: "fitter", label: "Monteur" },
    { slug: "laborer", label: "Arbeider" },
    { slug: "buyer", label: "Aankoper" },
    { slug: "heating-engineer", label: "Verwarmingsinstallateur" },
    { slug: "team-leader", label: "Ploegbaas" },
    { slug: "joiner", label: "Schrijnwerker" },
  ],
};

export const ADMINISTRATION_CATEGORIES = {
  fr: [
    { slug: "education-post", label: "Poste Éducatif" },
    { slug: "technical-sales-representative", label: "Représentant Technico-Commercial" },
    { slug: "manager", label: "Manager" },
  ],
  en: [
    { slug: "education-post", label: "Education Post" },
    { slug: "technical-sales-representative", label: "Technical Sales Representative" },
    { slug: "manager", label: "Manager" },
  ],
  nl: [
    { slug: "education-post", label: "Onderwijsfunctie" },
    { slug: "technical-sales-representative", label: "Technisch Commercieel Vertegenwoordiger" },
    { slug: "manager", label: "Manager" },
  ],
};

export const INDUSTRY_CATEGORIES = {
  fr: [
    { slug: "construction-materials", label: "Matériaux de construction" },
    { slug: "industrial-equipment", label: "Équipements industriels" },
    { slug: "metal-mechanical-manufacturing", label: "Fabrication métallique & mécanique" },
    { slug: "chemical-processes", label: "Chimie & procédés" },
    { slug: "energy-infrastructure", label: "Énergie & infrastructures" },
    { slug: "aerospace-defense", label: "Aérospatiale & défense" },
    { slug: "food-pharma", label: "Agroalimentaire & pharma" },
    { slug: "automotive-mobility", label: "Automobile & mobilité" },
    { slug: "robotics-automation", label: "Robotique & automatisation" },
    { slug: "water-treatment", label: "Traitement des eaux" },
    { slug: "recycling-circular-economy", label: "Recyclage & économie circulaire" },
    { slug: "logistics-warehousing", label: "Logistique & entreposage" },
    { slug: "naval-offshore", label: "Navale & offshore" },
    { slug: "instrumentation-control", label: "Instrumentation & contrôle" },
  ],
  en: [
    { slug: "construction-materials", label: "Construction materials" },
    { slug: "industrial-equipment", label: "Industrial equipment" },
    { slug: "metal-mechanical-manufacturing", label: "Metal & mechanical manufacturing" },
    { slug: "chemical-processes", label: "Chemistry & processes" },
    { slug: "energy-infrastructure", label: "Energy & infrastructure" },
    { slug: "aerospace-defense", label: "Aerospace & defence" },
    { slug: "food-pharma", label: "Agri-food & pharma" },
    { slug: "automotive-mobility", label: "Automotive & mobility" },
    { slug: "robotics-automation", label: "Robotics & automation" },
    { slug: "water-treatment", label: "Water treatment" },
    { slug: "recycling-circular-economy", label: "Recycling & circular economy" },
    { slug: "logistics-warehousing", label: "Logistics & warehousing" },
    { slug: "naval-offshore", label: "Naval & offshore" },
    { slug: "instrumentation-control", label: "Instrumentation & control" },
  ],
  nl: [
    { slug: "construction-materials", label: "Bouwmaterialen" },
    { slug: "industrial-equipment", label: "Industriële uitrusting" },
    { slug: "metal-mechanical-manufacturing", label: "Metaal- & mechanische fabricage" },
    { slug: "chemical-processes", label: "Chemie & processen" },
    { slug: "energy-infrastructure", label: "Energie & infrastructuur" },
    { slug: "aerospace-defense", label: "Lucht- & ruimtevaart & defensie" },
    { slug: "food-pharma", label: "Agrovoeding & farma" },
    { slug: "automotive-mobility", label: "Auto & mobiliteit" },
    { slug: "robotics-automation", label: "Robotica & automatisering" },
    { slug: "water-treatment", label: "Waterbehandeling" },
    { slug: "recycling-circular-economy", label: "Recyclage & circulaire economie" },
    { slug: "logistics-warehousing", label: "Logistiek & opslag" },
    { slug: "naval-offshore", label: "Scheepvaart & offshore" },
    { slug: "instrumentation-control", label: "Instrumentatie & controle" },
  ],
};

const tagWithIndustry = (items, industry) =>
  items.map(obj => ({ ...obj, industry }));

const merge = (...arrays) => arrays.flat();

export const JOB_CATEGORIES = {
  fr: merge(
    tagWithIndustry(ARCHITECTURE_CATEGORIES.fr, "architecture"),
    tagWithIndustry(ENGINEERING_CATEGORIES.fr, "engineering"),
    tagWithIndustry(CONSTRUCTION_CATEGORIES.fr, "construction"),
    tagWithIndustry(ADMINISTRATION_CATEGORIES.fr, "administration"),
    tagWithIndustry(INDUSTRY_CATEGORIES.fr, "industry")
  ),
  en: merge(
    tagWithIndustry(ARCHITECTURE_CATEGORIES.en, "architecture"),
    tagWithIndustry(ENGINEERING_CATEGORIES.en, "engineering"),
    tagWithIndustry(CONSTRUCTION_CATEGORIES.en, "construction"),
    tagWithIndustry(ADMINISTRATION_CATEGORIES.en, "administration"),
    tagWithIndustry(INDUSTRY_CATEGORIES.en, "industry")
  ),
  nl: merge(
    tagWithIndustry(ARCHITECTURE_CATEGORIES.nl, "architecture"),
    tagWithIndustry(ENGINEERING_CATEGORIES.nl, "engineering"),
    tagWithIndustry(CONSTRUCTION_CATEGORIES.nl, "construction"),
    tagWithIndustry(ADMINISTRATION_CATEGORIES.nl, "administration"),
    tagWithIndustry(INDUSTRY_CATEGORIES.nl, "industry")
  )
};

// fr-fr uses same content as fr (French market)
ARCHITECTURE_CATEGORIES["fr-fr"] = ARCHITECTURE_CATEGORIES.fr;
ENGINEERING_CATEGORIES["fr-fr"] = ENGINEERING_CATEGORIES.fr;
CONSTRUCTION_CATEGORIES["fr-fr"] = CONSTRUCTION_CATEGORIES.fr;
ADMINISTRATION_CATEGORIES["fr-fr"] = ADMINISTRATION_CATEGORIES.fr;
INDUSTRY_CATEGORIES["fr-fr"] = INDUSTRY_CATEGORIES.fr;
JOB_CATEGORIES["fr-fr"] = JOB_CATEGORIES.fr;
